const Url= {
    imageUrl: 'https://img.trailique.ai/',
    apiUrl: 'https://blogapi.trailique.ai/',
    blogimg:'https://blogapi.trailique.ai/blog/',
    caseimg:'https://blogapi.trailique.ai/study/'
}

export default Url;